/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES 料金システム用 API
 * PR TIMES 料金システムで使うAPI。
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * プランを予約する際にPOSTするBody
 * @export
 * @interface PostBookingPlanBody
 */
export interface PostBookingPlanBody {
    /**
     * プランID
     * "02" -> 従量課金プラン
     * "03" -> 月間契約プラン
     * "04" -> 半年間契約プラン
     * "05" -> 年間契約プラン
     * @type {string}
     * @memberof PostBookingPlanBody
     */
    planId: string;
    /**
     * 自動更新するか
     * @type {boolean}
     * @memberof PostBookingPlanBody
     */
    isAutoRenewable: boolean;
    /**
     * 一括請求か
     * @type {boolean}
     * @memberof PostBookingPlanBody
     */
    isLumpSumPayment: boolean;
    /**
     * プラン開始日 フォーマット(YYYYmmdd)
     * @type {string}
     * @memberof PostBookingPlanBody
     */
    startDate: string;
}

export function PostBookingPlanBodyFromJSON(json: any): PostBookingPlanBody {
    return PostBookingPlanBodyFromJSONTyped(json, false);
}

export function PostBookingPlanBodyFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostBookingPlanBody {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'planId': json['plan_id'],
        'isAutoRenewable': json['is_auto_renewable'],
        'isLumpSumPayment': json['is_lump_sum_payment'],
        'startDate': json['start_date'],
    };
}

export function PostBookingPlanBodyToJSON(value?: PostBookingPlanBody | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'plan_id': value.planId,
        'is_auto_renewable': value.isAutoRenewable,
        'is_lump_sum_payment': value.isLumpSumPayment,
        'start_date': value.startDate,
    };
}

